//import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { storeAccessor } from '../store/storeAccessor';

let loadingCnt = 0;
axios.interceptors.request.use(req => {
	// リクエストはローディングを開始する
	++loadingCnt;
	storeAccessor.setIsLoading(true);
	return req;
});
axios.interceptors.response.use(
	response => {
		// レスポンス、エラー返却時はローディングを終了する
		--loadingCnt;
		if(loadingCnt <= 0){
			storeAccessor.setIsLoading(false);
		}
		return Promise.resolve(response);
	},
	error => {
		--loadingCnt;
		if(loadingCnt <= 0){
			storeAccessor.setIsLoading(false);
		}
		return Promise.reject(error);
	}
);
//Vue.use(VueAxios, axios);
//export { axios };
const init = (app) => {
	app.use(VueAxios, axios);
};
export {
	init,
	axios,
};